import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { AccordianList } from "../../blocks/AccordianList";
import { SpecialOfferList } from "../../blocks/SpecialOfferList";
import { WarrantyFrame } from "../../blocks/WarrantyFrame";
import { toolboxComponentsMap } from "../../blocks/toolboxComponentsMap";

/**
 * sealy BasicPage body assembly (#33585): ``BasicPageContent`` = the 30
 * Toolbox keys + 3 legacy page-specific keys, all real ported components --
 * no legacy pre-rendered HTML strings remain on this page.
 * ``warranty_frame`` was ported in #33285 batch A, ``accordian_list`` in
 * batch B and ``special_offers_list`` in batch C.
 *
 * WRAPPER PARITY (load-bearing): the legacy ``cms/basic_page.html`` rendered
 * ``{{ self.body }}`` -- the whole StreamField, equivalent to
 * ``{% include_block self.body %}`` -- so every top-level block got Wagtail's
 * ``<div class="w-block-{type} block-{type}">`` wrapper. Reproduced verbatim
 * for EVERY block via the per-block ``StreamField tagName="div"`` render,
 * exactly like the GenericPage assembly: wrapper div -> block markup, no
 * extra host element.
 */
export const basicPageComponentsMap = {
    ...toolboxComponentsMap,
    accordian_list: AccordianList,
    special_offers_list: SpecialOfferList,
    warranty_frame: WarrantyFrame,
} as const;

export const BasicPageBody = (
    props: Immutable<{ page: templates.BasicPageTemplate["page"] }>,
): React.JSX.Element | null => {
    // `body` is nullable (`null=True` on the model field).
    if (!props.page.body) {
        return null;
    }
    return (
        <>
            {props.page.body.value.map((block) => (
                <StreamField
                    key={block.id}
                    tagName="div"
                    attrs={{
                        className: `w-block-${block.type} block-${block.type}`,
                    }}
                    value={[block]}
                    components={basicPageComponentsMap}
                />
            ))}
        </>
    );
};
